import React from "react";
import Icon from "./icon";
import { formatDate, DateRange } from "../utility/print-date";
import { Link } from "gatsby";
import { useTranslation } from "react-i18next";
import { useTranslateCategory } from "../utility/category-translation";

const Meta = ({
  type,
  title,
  category,
  date,
  startDate,
  endDate,
  city,
  country,
  infoUrl,
  tags,
  url,
}) => {
  const { i18n, t } = useTranslation();
  const translateCategory = useTranslateCategory();
  return (
    <div className="meta bgcolor--gray-light">
      <div className="container">
        <div className="row gap-3 gap-lg-5">
          {category && type !== "Event" && (
            <div className="col-lg">
              <div className="meta__item">
                <div className="pre-title mb-3">{t("category")}</div>
                <div className="box__tag">
                  {translateCategory(category, type === "Blog" ? "blog" : "news")}
                </div>
              </div>
            </div>
          )}
          {date && type !== "Event" && (
            <>
              <div className="col-lg">
                <div className="meta__item">
                  <div className="pre-title mb-3">{t("date")}</div>
                  <div>
                    <span className="box__divider-vert box__divider-vert--primary"></span>
                    <span className="meta__date color-secondary-light">
                      {formatDate(date, i18n.language)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg d-none d-lg-flex flex-grow-0">
                <div className="box__divider-oriz"></div>
              </div>
            </>
          )}
          {startDate && (
            <>
              <div className="col-lg">
                <div className="meta__item">
                  <div className="pre-title mb-3">{t("date")}</div>
                  <div>
                    <span className="h4 color-primary">
                      <DateRange end={endDate} showYear start={startDate} />
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg d-none d-lg-flex flex-grow-0">
                <div className="box__divider-oriz"></div>
              </div>
            </>
          )}
          {city && type === "Event" && (
            <>
              <div className="col-lg">
                <div className="meta__item">
                  <div className="pre-title mb-3">{t("location")}</div>
                  <div>
                    <span className="color-secondary-light text-uppercase">
                      {city}
                      {country ? `, ${country}` : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg d-none d-lg-flex flex-grow-0">
                <div className="box__divider-oriz"></div>
              </div>
            </>
          )}
          {infoUrl && type === "Event" && (
            <>
              <div className="col-lg">
                <div className="meta__item flex-grow-0">
                  <div className="pre-title mb-3">{t("information")}</div>
                  <a
                    href={`${infoUrl}`}
                    className="meta__info-link color-primary"
                    target="_blank"
                    rel="noreferrer"
                    title={`${infoUrl}`}
                  >
                    {infoUrl.replace(/https?:\/\//, "")}
                  </a>
                </div>
              </div>
              <div className="col-lg d-none d-lg-flex flex-grow-0">
                <div className="box__divider-oriz"></div>
              </div>
            </>
          )}
          {tags && (
            <>
              <div className="col-lg">
                <div className="meta__item">
                  <div className="pre-title mb-3">{t("tags")}</div>
                  <div>
                    {tags?.map((tag, index) => (
                      <Link
                        to={`/insights/?tag=${tag}`}
                        className="me-2 color-secondary-light"
                        key={index}
                      >{`#${tag}`}</Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-lg d-none d-lg-flex flex-grow-0">
                <div className="box__divider-oriz"></div>
              </div>
            </>
          )}
          {title && url && (
            <div className="col-lg">
              <div className="meta__item">
                <div className="pre-title mb-3">{t("share")}</div>
                <div>
                  <a
                    href={`https://twitter.com/intent/tweet?text=${title} at ${url}`}
                    target="__blank"
                    rel="noreferrer"
                  >
                    <Icon name="x-twitter" className="color-primary" width={28} height={23} />
                  </a>
                  <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon name="linkedin" className="color-primary ms-4" width={25} height={25} />
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Meta;
